import { t, useLanguage } from '@/lib/i18n'
import { useAuth } from '@/features/auth/auth-context'
import { selectedRelease } from '@/lib/release-channel'
import './release-banner.css'

export function ReleaseBanner() {
  const language = useLanguage()
  const { profile } = useAuth()
  if (profile?.user.role !== 'admin' || selectedRelease()?.channel !== 'preview') return null
  return <aside className="release-banner" lang={language} dir={language === 'ar' ? 'rtl' : 'ltr'} aria-label={t("Release environment")}>
    <strong>{t("Admin preview · Live data")}</strong>
    <span>{t("Changes here affect live records.")}</span>
  </aside>
}
